module.exports = __webpack_public_path__ + "792c1ba4a217e72de6e247319da9404f.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/arandu-pintureria.png
// module id = 584
// module chunks = 0